export const DROPDOWN_TYPES = {
  ActivitiesType: 'activitiesType',
  CustomerType: 'customerType',
  OrderType: 'orderType',
  StoreSelector: 'storeSelector',
  Actions: 'actions',
  Schedule: 'schedule',
  SalesTargetType: 'salesTargetType',
  PointMultiplierRulesCriteria: 'rulesCriteria',
  PointMultiplierSegment: 'segment',
  PointMultiplierCategory: 'category',
  PointMultiplierChannel: 'channel',
  RewardsCatalogAction: 'rewardCatalogAction',
  RewardTypes: 'rewardTypes',
  RewardSegments: 'rewardSegments',
  BonusProducts: 'bonusProducts',
  RewardCardTypes: 'visaCardType'
};
